import {
  svgRectToOverlayPct,
} from './modifierOverlayCoords';

const MU_PLAY_STRIP_OFFSET_Y = 981.438;
const MU_PLAY_STRIP_HEIGHT = 929.588;

/** Масштаб спрайта метеора относительно layout SVG. */
const MU_OVERLAY_SIZE_SCALE = 2;

export type MuOverlayPath = {
  id: string;
  srcKey: 'm_1' | 'm_2' | 'm_3' | 'm_4';
  startXPct: number;
  startYPct: number;
  finishXPct: number;
  finishYPct: number;
  widthPct: number;
  heightPct: number;
};

function muLocalY(absoluteSvgY: number): number {
  return absoluteSvgY - MU_PLAY_STRIP_OFFSET_Y;
}

function muPath(
  id: string,
  srcKey: MuOverlayPath['srcKey'],
  startSvgX: number,
  startSvgY: number,
  finishSvgX: number,
  finishSvgY: number,
  widthSvg: number,
  heightSvg: number,
): MuOverlayPath {
  const startLocalY = muLocalY(startSvgY);
  const finishLocalY = muLocalY(finishSvgY);
  const start = svgRectToOverlayPct(
    startSvgX,
    startLocalY,
    widthSvg,
    heightSvg,
    MU_PLAY_STRIP_HEIGHT,
  );
  const finish = svgRectToOverlayPct(
    finishSvgX,
    finishLocalY,
    widthSvg,
    heightSvg,
    MU_PLAY_STRIP_HEIGHT,
  );
  return {
    id,
    srcKey,
    startXPct: start.xPct,
    startYPct: start.yPct,
    finishXPct: finish.xPct,
    finishYPct: finish.yPct,
    widthPct: start.widthPct * MU_OVERLAY_SIZE_SCALE,
    heightPct: start.heightPct * MU_OVERLAY_SIZE_SCALE,
  };
}

/** From Moon mu.svg meteor paths (absolute → play-strip local Y). */
export const MU_OVERLAY_PATHS: readonly MuOverlayPath[] = [
  muPath('mu_meteor_m-2', 'm_1', 7505.5, 285.6258, 5176.5, 2288.625, 438.78, 517.5524),
  muPath('mu_meteor_m-2_2', 'm_2', 8735.76, 285.6258, 6406.76, 2288.625, 438.78, 517.5524),
  muPath('mu_meteor_m-1', 'm_3', 8227.46, 143.7155, 5898.46, 2146.715, 246.78, 287.431),
  muPath('mu_meteor_m-1_2', 'm_3', 6969.93, 216.0732, 4640.93, 2219.075, 246.78, 287.4316),
  muPath('mu_meteor_m-4', 'm_4', 8301.575, 513.6465, 5972.575, 2516.645, 425.27, 543.985),
  muPath('mu_meteor_m-4_2', 'm_4', 6968.265, 527.9395, 4639.265, 2530.94, 425.27, 543.985),
  muPath('mu_meteor_m-3', 'm_4', 7611.05, 707.637, 5282.055, 2710.635, 387.72, 460.274),
] as const;
